<!-- =========================================================================================
    File Name: PartnerUnjoin.vue
    Description: Отвязывание устройств от партнера
========================================================================================== -->


<template>
    <vs-prompt
        title="Отвязывание устройств от партнера"
        accept-text= "Отвязать"
        cancel-text = "Закрыть"
        button-cancel = "border"
        @accept="submitDeviceTransfer"
        :is-valid="validateForm"
        :active.sync="activePrompt">
        <div>
            <form>

                <div class="vx-row">
                    <div class="vx-col w-full">
                        <p>Выберите партнера, которому хотите передать.</p>
                        <!-- <vs-input v-validate="'required'" name="title" class="w-full mb-4 mt-5" placeholder="Название" v-model="programLocal.name" /> -->
                        <!-- <vs-textarea rows="5" label="Описание" v-model="programLocal.descr" /> -->
                        <vs-select v-model="partnerId" label="Партнер" class="w-150">
                            <vs-select-item class="w-150" :key="item.partid" :value="item.partid" :text="item.company" v-for="item in partnerList" />
                        </vs-select>
                    </div>
                </div>

            </form>
        </div>
    </vs-prompt>
</template>

<script>
import modulePartner          from '@/store/partner/modulePartner.js'

export default {
    props: {
        displayPrompt: {
            type: Boolean,
            required: true,
        },
        devices: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            partnerDeviceStateList: modulePartner.partnerDeviceStateList,
            partnerId: 0,
        }
    },
    computed: {
        partnerList() {
            return this.$store.state.partner.partners
        },
        activePrompt: {
            get() {
                return this.displayPrompt
            },
            set(value) {
                this.$emit('hidePromptUnjoin', value)
            }
        },
        validateForm() {
            return !this.errors.any() && this.partnerId !== 0
        }
    },
    methods: {
        submitDeviceTransfer() {
            this.$store.dispatch("partner/createPartnerDevice", {partid: this.partnerId, devices: this.devices})
        }

    },
    created() {
        if (!modulePartner.isRegistered) {
            this.$store.registerModule('partner', modulePartner)
            modulePartner.isRegistered = true
        }

        this.$store.dispatch("partner/fetchPartners")
    }
}
</script>

<style lang="scss">

    .con-select {
        width: 350px;
    }

</style>